import DOMPurify from 'dompurify'

// A reply is composed outside the application by someone with no account, so it is
// sanitized here, at display, and never on the way in: the stored message is the record of
// what was actually sent, and a later fix here protects the replies already retained.
const CONFIGURATION = {
    FORBID_TAGS: [
        'img',
        'svg',
        'video',
        'audio',
        'iframe',
        'object',
        'embed',
        'form',
        'input',
        'button',
        'textarea',
        'select',
        'style',
    ],
    FORBID_ATTR: ['style', 'srcset'],
    ALLOW_DATA_ATTR: false,
}

export function sanitizeReplyBody(body) {
    if (body == null) {
        return ''
    }

    return DOMPurify.sanitize(body, CONFIGURATION)
}
